<template>
    <Loader v-if="loading" :loading='loading' :size='45' />
    <div v-else>
        <div class="input-container">
            <label for="imageInput" class="custom-file-upload">{{!selectedImage ? 'Select image' : 'Change image'}}</label>
            <input id="imageInput" @change="handleImageUpload" type="file" accept="image/*" style="display: none" >
        </div>
        <div class="original-image" v-if="selectedImage">
            <div class="img-container">
                <img ref="image" :src="selectedImage" alt="Original Image" @load="initializeCropper" />
            </div>
            <div class="btn-container">
                <button @click="saveImage" class="btn-save">Save</button>
            </div>
        </div>
    </div>
</template>

<script>
import Cropper from "cropperjs";
import "cropperjs/dist/cropper.css";
import uploadService from "../../services/uploadService";
import Loader from '../../shared-components/Loader';
import { mapState } from 'vuex';

export default {
    components: {
        Loader,
    },
    props: {
        aspect: {
            type: String,
        },
    },
    data() {
        return {
            cropper: null,
            destination: null,
            selectedImage: null,
            imageLoaded: false,
            aspectRatio: "",
            customThumbnail: null, // image 16x9
            heroImage: null, // image 9x4
            thumbnail2x3: null, // image 2x3
            customThumbnailGallery: null, // image 16x9
            heroImageGallery: null, // image 9x4
            thumbnail2x3Gallery: null, // image 2x3
            croppedImageTemp: null,
            isAlertVisible: false,
            aspectImageSelected: '',
            loading: false,
        };
    },
    computed: {
    ...mapState({
            accountID: (state) => state.user.siteuser.user_metadata.account_id,
        }),
    },
    methods: {
        handleImageUpload(event) {
            const file = event.target.files[0];
            if (file) {
                const reader = new FileReader();
                reader.onload = () => {
                    this.selectedImage = reader.result;
                    this.imageLoaded = false;
                };
                reader.readAsDataURL(file);
            }
        },
        initializeCropper() {
            setTimeout(() => {
                if (this.cropper) {
                    this.cropper.destroy();
                }
                if (this.$refs.image.complete) {
                    this.createCropper();
                } else {
                    this.$refs.image.onload = this.createCropper;
                }
            }, 100);
        },
        createCropper() {
            this.aspectRatio = this.aspect;
            this.cropper = new Cropper(this.$refs.image, {
                zoomable: false,
                scalable: true,
                viewMode: 1,
                autoCropArea: .95,
                aspectRatio: eval(this.aspectRatio),
                crop: this.updateDestination,
            });
            this.imageLoaded = true;
        },
        updateDestination() {
            if (this.imageLoaded) {
                const canvas = this.cropper.getCroppedCanvas({
                    width: this.aspectRatio === "16/9"  ? 960 : (this.aspectRatio === "9/4" ? 960 : 360),
                    height: this.aspectRatio === "16/9" ? 540 : (this.aspectRatio === "9/4" ? 427 : 540) ,
                });
                if (canvas) {
                    this.croppedImageTemp = canvas.toDataURL("image/jpeg");
                }
            }
        },
        changeAspectRatio(newAspectRatio) {
            this.aspectRatio = newAspectRatio;
        },
        saveImage() {
            const userId = window.localStorage.getItem('impersonate') || this.accountID;
            if (this.aspectRatio == "16/9") {
                this.customThumbnail = this.croppedImageTemp;
                const url = this.croppedImageTemp;
                fetch(url)
                    .then(res => res.blob())
                    .then(blob => {
                        this.loading = true;
                        const file = new File([blob], "File poster", { type: "image/jpeg" })
                        uploadService.uploadCustom(file, this, userId)
                            .then((path) => {
                                this.$emit('uploadCustomThumbnail', { url: `${path}` });
                                this.selectedImage = null;
                                this.loading = false;
                            })
                    })
            }
            if (this.aspectRatio == "9/4") {
                this.heroImage = this.croppedImageTemp
                const url = this.croppedImageTemp;
                fetch(url)
                    .then(res => res.blob())
                    .then(blob => {
                        this.loading = true;
                        const file = new File([blob], "File hero", { type: "image/jpeg" })
                        uploadService.uploadHeroImage(file, this, userId)
                            .then((path) => {
                                this.$emit('uploadHero', { url: `${path}` });
                                this.selectedImage = null;
                                this.loading = false;
                            })
                    })
            };
            if (this.aspectRatio == "2/3") {
                this.thumbnail2x3 = this.croppedImageTemp
                const url = this.croppedImageTemp;
                fetch(url)
                    .then(res => res.blob())
                    .then(blob => {
                        this.loading = true;
                        const file = new File([blob], "File portrait", { type: "image/jpeg" })
                        uploadService.uploadThumbnail2x3(file, this, userId)
                            .then((path) => {
                                this.$emit('upload2x3', { url: `${path}` });
                                this.selectedImage = null;
                                this.loading = false;
                            })
                    })
            };
        },
    },
    watch: {
        selectedImage(newValue) {
            if (newValue) {
                this.initializeCropper();
            }
        },
        aspect(newValue) {
            if (this.cropper) {
                this.cropper.setAspectRatio(eval(newValue));
            }
        },
    },
};
</script>

<style scoped>
.original-image {
    display: flex;
    margin-right: 10px;
}

.original-image img {
    max-width: 450px;
    max-height: 450px;
}
.img-container{
    max-width: 600px;
    max-height: 400px;
    overflow: hidden;

}
.img-container button{
    margin-left: 15px;
}
.img-container img {
    display: block;
    background: none;
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
}

.btn-container{
    /* background-color: red; */
    display: flex;
    align-items: center;
    justify-content: center;
    margin: auto;
}
.btn-save {
    padding: 15px 30px;
    cursor: pointer;
    background-color: transparent;
    border: 1px solid #45a049;
    border-radius: 5px;
    font-size: 16px;
    transition: all 0.1s ease-in-out;

    &:hover {
        color: #fff;
        background-color: #45a049;
    }
}
.input-container{
    display: flex;
    justify-content: center;
}
.custom-file-upload {
    display: inline-block;
    padding: 10px 20px;
    cursor: pointer;
    background-color: transparent;
    border: 1px solid #4785a9;
    border-radius: 5px;
    margin-bottom: 20px;
    transition: all 0.1s ease-in-out;
}

.custom-file-upload:hover {
    color: #fff;
    background-color: #4785a9;
}
</style>



// WEBPACK FOOTER //
// src/shared-components/upload/CropperImage.vue